<template>
  <div class="w3-container">
    <form class="w3-card w3-margin-top w3-padding" @submit.prevent="submit">
      <label>From</label>
      <input class="w3-input" type="date" v-model="start_date">

      <label>To</label>
      <input class="w3-input" type="date" v-model="end_date">

      <button class="w3-button w3-margin-top" type="submit" >Submit</button>
    </form>

    <div class="stats table">
      <table class="w3-table w3-bordered w3-border w3-striped">
        <tr>
          <th>ტესტი</th>
          <th>კოდი</th>
          <th>რაოდენობა</th>
        </tr>
        <tr v-for="(stat, index) in test_stats" v-bind:key="index">
          <td>{{stat.test_name}}</td>
          <td>{{stat.test_code}}</td>
          <td>{{stat.number_of_tests}}</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'statsPage',
  data: function(){
    return {
      start_date: null,
      end_date: null,
      test_stats: []
    }
  },
  methods: {
    ...mapActions({'getStats':'GET_STATS'}),
    submit(){
      console.log(this.start_date)
      console.log(this.end_date)
      let start_date = this.start_date
      let end_date = this.end_date
      axios.get('/php_scripts/' + 'get_stats_json.php', {
          params:{
            start_date: start_date,
            end_date: end_date
          }
        })
        .then((response) => {
          this.test_stats = response.data
        })
        .catch((error) => {
          console.log(error)
        })
       
    }
  }
}
</script>

<style scoped>

</style>